import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWifiOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.833252 0.833374L19.1666 19.1667M13.9333 9.21671C14.6158 9.54983 15.2541 9.96695 15.8333 10.4584M4.16659 10.4584C5.40165 9.42573 6.88815 8.73855 8.47492 8.46671M8.92492 4.20837C10.7103 4.06452 12.5063 4.28184 14.2058 4.84739C15.9053 5.41294 17.4734 6.3151 18.8166 7.50004M1.18325 7.50004C2.33922 6.47825 3.66467 5.66606 5.09992 5.10004M7.10825 13.425C7.95425 12.824 8.96631 12.5011 10.0041 12.5011C11.0419 12.5011 12.0539 12.824 12.8999 13.425M9.99992 16.6667H10.0083",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWifiOff;
